import { createServerFn } from '@tanstack/react-start';
import Airtable from 'airtable';
import { z } from 'zod';
import { env } from './env';

export const storeData = createServerFn({ method: 'POST' })
  .inputValidator(z.object({
    email: z.string().email(),
    name: z.string(),
    message: z.string(),
  }))
  .handler(async ({ data }) => {
    const airtable = new Airtable({
      apiKey: env.AIRTABLE_KEY,
    });

    try {
      await airtable.base('appeLCa3nIFJucHq0')('tblJf9zNqbw0yhTV2').create([
        {
          fields: {
            Email: data.email,
            Name: data.name,
            Notes: data.message,
          },
        },
      ]);

      return { success: true };
    }
    catch {
      return { success: false };
    }
  });
